import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  DocumentsList,
  FormFieldSet,
  NewTable,
  PageHeader,
  PageTitle,
  showToast,
  useFormHandler,
} from "../../../../components";
import {
  cityStateListOptions,
  countryListOptions,
  priorityOptions,
} from "../../../../assets/data/projectData";
import {
  BankAccType,
  DepositAmtType,
  RecordStatus,
} from "../../../../assets/data/enumData";
import { useDispatch, useSelector } from "react-redux";
import {
  getVendorOneStart,
  updateVendorStart,
} from "../../../../redux/slices/vendor/vendorSlice";
import { filterEmptyValues } from "../../../../utils/filterEmptyValues";
import useDropdownData from "../../../../hooks/useDropdownData";
import { v4 as uuidv4 } from "uuid";
import { uploadStart } from "../../../../redux/slices/universal/fileUploadSlice";
import { mapTableRows } from "../../../../utils";
import { label } from "framer-motion/client";

const Confidential = ({
  setActiveTab,
  isEditable,
  editVendor = "",
  vendorId,
}) => {
  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const vendorProfileUiid = useSelector(
    (state) => state.vendor.vendorProfileUiid
  );
  const vendorDetails = useSelector(
    (state) => state.vendor.currentVendor.vendorDetails
  );
  const [docs, setDocs] = useState([]);
  const defaultValues={
   bankAccountName: "",
      bankName: "",
      accountType: "",
      abaRoutingNum: "",
      accountNum: "",
      depositAmt: "",
      priority: "",
      comments: "",
      address1: "",
      address2: "",
      country: "",
      state: "",
      city: "",
      zipCode: null,
      recordStatus: "",
      voidCheck: [],
      attachment: [],
  }
  const [defaultConfidential,setDefaultConfidential]=useState(defaultValues||{})
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    defaultConfidential,
    {
      bankAccountName: { type: "text", required: true },
      accountType: { type: "select", required: true },
      country: { type: "select", required: true },
      city: { type: "select", required: true },
      state: { type: "select", required: true },
      depositAmt: { type: "select", required: true },
      priority: { type: "select", required: true },
      recordStatus: { type: "select", required: true },
      bankName: { type: "text", required: true },
      comments: { type: "text", required: true },
      address1: { type: "text", required: true },
      address2: { type: "text", required: true },
      abaRoutingNum: { type: "alphanumeric",required: true },
      accountNum: { type: "alphanumeric",required: true },
      zipCode: { type: "text", number:true,required: true },
      voidCheck: { type: "file", required: true },
      attachment: { type: "file", required: true },
    }
  );
  const { data: countryOptions, handleScroll: handleCountriesScroll } =
    useDropdownData("countriesUsAndCanada");

  const countryId = countryOptions.find(
    (item) => item.label === formData.country
  )?.id;

  const {
    data: stateOptions,
    searchValue: stateSearch,
    handleSearch: handleStateSearch,
    resetSearch: resetStateSearch,
    handleScroll: handleStateScroll,
  } = useDropdownData(
    "states",
    10,
    { country: formData.country },
    { countrySearch: countryId }
  );

  const {
    data: cityOptions,
    searchValue: citySearch,
    handleSearch: handleCitySearch,
    resetSearch: resetCitySearch,
    handleScroll: handleCityScroll,
  } = useDropdownData(
    "cities",
    10,
    { country: formData.country, state: formData.state },
    { countrySearch: countryId, stateSearch: formData.state }
  );
  useEffect(() => {
    if (vendorProfileUiid) {
      dispatch(
        getVendorOneStart({
          vendorUiid: vendorProfileUiid,
          retrieve: `confidential`,
          // ref: `Contact`,
        })
      );
    }
  }, [vendorId]);

  const handleBack = () => {
    setTimeout(() => {
      // Move to back tab
      setActiveTab((prev) => prev - 1);
    }, 500);
  };

  const handleSave = () => {
    const isValid = validateAllFields();
    try {
      let filesToUpload = [
        ...formData.voidCheck,
        ...formData.attachment,
      ].map((file) => {
        file.id = uuidv4();
        return file;
      });


      if (isValid) {
        let confidentialPayload = filterEmptyValues({
          bankAccountName: formData.bankAccountName || undefined,
          bankName: formData.bankName || undefined,
          accountType: formData.accountType || undefined,
          abaRoutingNum: formData.abaRoutingNum || undefined,
          accountNum: formData.accountNum || undefined,
          depositAmt: formData.depositAmt || undefined,
          priority: formData.priority || undefined,
          comments: formData.comments || undefined,
          location: {
            address1: formData.address1 || undefined,
            address2: formData.address2 || undefined,
            country: formData.country || undefined,
            state: formData.state || undefined,
            city: formData.city || undefined,
            zipCode: formData.zipCode || undefined,
          },
          recordStatus: formData.recordStatus || undefined,
          // voidCheck: formData.voidCheck || undefined,
          // attachment: formData.attachment || undefined,
        });
              dispatch(
                uploadStart({
                  uploadType: "multiple",
                  field: "doc",
                  uiid: vendorProfileUiid,
                  entity: "vendor",
                  category: "documents",
                  coll: "Vendor",
                  doc: filesToUpload,
                  onSuccess: async (fileData) => {
                    console.log("fileData", fileData);
                    console.log("filesToUpload", filesToUpload);
                    const payload = [
                      {
                        type: "PUSH",
                        value: {
                          confidential: {
                            voidCheck: fileData.find(
                              (file) => file.fileRefId === filesToUpload[0].id
                            ).key,
                            attachment: fileData.find(
                              (file) => file.fileRefId === filesToUpload[1].id
                            ).key,
                            ...confidentialPayload,
                          },
                        },
                      },
                    ];
                    dispatch(
                      updateVendorStart({
                        coll: "Vendor",
                        uiid: vendorProfileUiid,
                        payload: payload,
                        onSuccess: () => {
                          dispatch(
                            getVendorOneStart({
                              vendorUiid: vendorProfileUiid,
                              retrieve: "confidential",
                            })
                          );
                          setDefaultConfidential(defaultValues)
                          setActiveTab((prev) => prev + 1);
                        },
                      })
                    );
                  },
                })
              );
      } else {
        console.log("Please fix the errors before submitting.");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
    }
  };
const AllConfidentialColumns=[

    { key: "bankAccountName", label: "Name in bank account" },
    { key: "bankName", label: "Bank Name" },
   {
  key: "accountType",
  label: "Account Type",
  render: (row) => {
    const matched = BankAccType.find(
      (data) => String(data.value) === String(row.accountType)
    );
    return <>{matched?.label || '-'}</>;
  },
},
    { key: "abaRoutingNum", label: "ABA routing number" },
    { key: "accountNum", label: "Account number" },
    { key: "depositAmt", label: "Deposit amount", render: (row) => {
    const matched = DepositAmtType.find(
      (data) => String(data.value) === String(row.accountType)
    );
    return <>{matched?.label || '-'}</>;
  } },
    { key: "priority", label: "Priority" },
    { key: "comments", label: "Comments" },
  {
  key: "address1",
  label: "Address1",
  render: (row) => {
    return (
      <>{row?.location?.address1 || '-'}</>
    );
  }
},
    { key: "address2", label: "Address2", render: (row) => {
    return (
      <>{row?.location?.address2 || '-'}</>
    );
  } },
    { key: "country", label: "Country", render: (row) => {
    return (
      <>{row?.location?.country || '-'}</>
    );
  } },
    { key: "state", label: "State", render: (row) => {
    return (
      <>{row?.location?.state || '-'}</>
    );
  } },
    { key: "city", label: "City", render: (row) => {
    return (
      <>{row?.location?.city || '-'}</>
    );
  } },
    { key: "zipCode", label: "ZipCode", render: (row) => {
    return (
      <>{row?.location?.zipCode || '-'}</>
    );
  } },
  {
 key:"recordStatus",label:"Record Status",render: (row) => {
    const matched = RecordStatus.find(
      (data) => String(data.value) === String(row.accountType)
    );
    return <>{matched?.label || '-'}</>;
  } 
  },
{
  key: "voidCheck",
  label: "Void Check",
  render: (row) => {
    if (!row?.voidCheck) return <>-</>; // Optional: fallback if no file
    return (
      <DocumentsList
        data={[
          {
            filePath: row.voidCheck,
            name: "Void Check",
          },
        ]}
        type="inner"
      />
    );
  },
},
{
  key: "attachment",
  label: "Attachment",
  render: (row) => {
    if (!row?.attachment) return <>-</>; // Optional: fallback if no file
    return (
      <DocumentsList
        data={[
          {
            filePath: row.attachment,
            name: "Attachments",
          },
        ]}
        type="inner"
      />
    );
  },
},
      {
        key: "action",
        label: "",
         render: (row) => (
          <></>
        // <CustomSelect
        //   type="select"
        //   title=""
        //   placeholder="Discount"
        //   value={formData.Discount}
        //   onChange={(value) => handleChange("Discount", value)}
        //   error={errors.Discount}
        //   size='xs'
        // />
      ),
        sortable: false,
      },
  ];
     const confidentialRow = Array.isArray(vendorDetails?.confidential) && vendorDetails.confidential.length > 0
  ? vendorDetails.confidential
  : [];
    const mappedRows = mapTableRows(confidentialRow, AllConfidentialColumns);
//      useEffect(() => {
//   const confidentialArray = vendorDetails?.confidential;
//   const confidential =
//     Array.isArray(confidentialArray) && confidentialArray.length > 0
//       ? confidentialArray[confidentialArray.length - 1]
//       : null;

//   if (confidential) {
//     handleChange("bankAccountName", confidential.bankAccountName || "");
//     handleChange("bankName", confidential.bankName || "");
//     handleChange("accountType", confidential.accountType || "");
//     handleChange("abaRoutingNum", confidential.abaRoutingNum?.toString() || "");
//     handleChange("accountNum", confidential.accountNum?.toString() || "");
//     handleChange("depositAmt", confidential.depositAmt || "");
//     handleChange("priority", confidential.priority || "");
//     handleChange("comments", confidential.comments || "");

//     // Location fields
//     const location = confidential.location || {};
//     handleChange("address1", location.address1 || "");
//     handleChange("address2", location.address2 || "");
//     handleChange("country", location.country || "");
//     handleChange("state", location.state || "");
//     handleChange("city", location.city || "");
//     handleChange("zipCode", location.zipCode?.toString() || "");

//     handleChange("recordStatus", confidential.recordStatus || "");

//     const voidCheckLink = confidential.voidCheck || "";
//     const attachmentLink = confidential.attachment || "";

//     setDocs([voidCheckLink, attachmentLink]);
//   } else {
//     // Optionally clear values if confidential is not available
//     setDocs([]);
//   }
// }, [vendorDetails]);

  return (
    <div className="flex flex-col overflow-auto rounded w-full h-full px-8 py-3">
      <div className="mb-8">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Confidential"} icon={"badge"} tag="h5" />
            </div>
          }
          RightSection={
            <>
              {isEditable && (
                <>
                  <Button
                    title="Back"
                    size="sm"
                    icon={"arrow_left_alt"}
                    onClick={handleBack}
                  />
                  <Button title="Save" size="sm" onClick={()=>handleSave()} />
                </>
              )}
            </>
          }
        />
      </div>
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6  max-w-7xl ">
        <FormFieldSet
          type="text"
          title="Name In Bank Account"
          placeholder="Enter Name"
          value={formData.bankAccountName}
          onChange={(value) => handleChange("bankAccountName", value)}
          error={errors.bankAccountName}
          disabled={!isEditable}
        />
        <FormFieldSet
          type="text"
          title="Bank Name"
          placeholder="Enter Bank Name"
          value={formData.bankName}
          onChange={(value) => handleChange("bankName", value)}
          error={errors.bankName}
          disabled={!isEditable}
        />
        <FormFieldSet
          type="select"
          title="Account Type"
          placeholder="Select Account Type"
          value={formData.accountType}
          onChange={(value) => handleChange("accountType", value)}
          error={errors.accountType}
          options={BankAccType}
          disabled={!isEditable}
        />
        <FormFieldSet
          type="text"
          title="ABA Routing Number"
          placeholder="Enter ABA Routing Number"
          value={formData.abaRoutingNum}
          onChange={(value) => handleChange("abaRoutingNum", value)}
          error={errors.abaRoutingNum}
          disabled={!isEditable}
          alphanumeric
        />
        <FormFieldSet
          type="text"
          title="Account Number"
          placeholder="Enter Account Number"
          value={formData.accountNum}
          onChange={(value) => handleChange("accountNum", value)}
          error={errors.accountNum}
          disabled={!isEditable}
          alphanumeric
        />
        <FormFieldSet
          type="select"
          title="Deposit Amount"
          placeholder="Select Deposit Amount"
          value={formData.depositAmt}
          onChange={(value) => handleChange("depositAmt", value)}
          error={errors.depositAmt}
          options={DepositAmtType}
          disabled={!isEditable}
        />

        <div className="col-span-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6">
          <FormFieldSet
            type="select"
            title="Priority"
            placeholder="Select Priority"
            value={formData.priority}
            onChange={(value) => handleChange("priority", value)}
            error={errors.priority}
            options={priorityOptions}
            disabled={!isEditable}
          />
          <FormFieldSet
            type="text"
            title="Comments"
            placeholder="Enter Comments"
            value={formData.comments}
            onChange={(value) => handleChange("comments", value)}
            error={errors.comments}
            disabled={!isEditable}
          />
        </div>

        <FormFieldSet
          type="text"
          title="Address Line 1"
          placeholder="Enter Address"
          value={formData.address1}
          onChange={(value) => handleChange("address1", value)}
          error={errors.address1}
          disabled={!isEditable}
        />
        <FormFieldSet
          type="text"
          title="Address Line 2"
          placeholder="Enter Address"
          value={formData.address2}
          onChange={(value) => handleChange("address2", value)}
          error={errors.address2}
          disabled={!isEditable}
        />
        <FormFieldSet
          type="select"
          title="Country"
          keyname="countries"
          placeholder="Select Country"
          options={countryOptions}
          value={formData.country}
          onChange={(value) => handleChange("country", value)}
          error={errors.country}
          // options={countryListOptions}
          disabled={!isEditable}
        />
        <FormFieldSet
          type="select"
          title="State"
          keyname="states"
          placeholder="Select State"
          value={formData.state}
          onChange={(value) => handleChange("state", value)}
          error={errors.state}
          // options={cityStateListOptions}
          options={stateOptions}
          searchValue={stateSearch}
          onSearch={handleStateSearch}
          onClose={resetStateSearch}
          showSearch
          refData={containerRef}
          handleScroll={() => handleStateScroll(containerRef)}
          disabled={!isEditable}
        />
        <FormFieldSet
          type="select"
          title="City"
          keyname="cities"
          options={cityOptions}
          searchValue={citySearch}
          onSearch={handleCitySearch}
          onClose={resetCitySearch}
          showSearch
          refData={containerRef}
          handleScroll={() => handleCityScroll(containerRef)}
          placeholder="Enter City"
          value={formData.city}
          onChange={(value) => handleChange("city", value)}
          error={errors.city}
          disabled={!isEditable || !formData.country || !formData.state}
        />
        {/* <FormFieldSet
                    type="select"
                    title="City"
                    keyname="cities"
                    placeholder="Select City"
                    options={cityOptions}
                    searchValue={citySearch}
                    onSearch={handleCitySearch}
                    onClose={resetCitySearch}
                    showSearch
                    value={formData.city}
                    onChange={(value) => handleChange("city", value)}
                    error={errors.city}
                    disabled={!isEditable || !formData.country || !formData.state}
                    refData={containerRef}
                    handleScroll={() => handleCityScroll(containerRef)}
                  /> */}
        <FormFieldSet
          type="text"
          title="Zip Code"
          placeholder="Enter Zipcode"
          value={formData.zipCode}
          onChange={(value) => handleChange("zipCode", value)}
          error={errors.zipCode}
          disabled={!isEditable}
        />
        <FormFieldSet
          type="select"
          title="Record Status"
          placeholder="Select Record Status"
          value={formData.recordStatus}
          onChange={(value) => handleChange("recordStatus", value)}
          error={errors.recordStatus}
          options={RecordStatus}
          disabled={!isEditable}
        />
        <FormFieldSet
          type="file"
          title="Void Check"
          placeholder="No file Chosen"
          onChange={(files) => handleChange("voidCheck", files)}
          value={formData.voidCheck}
          error={errors.voidCheck}
          disabled={!isEditable}
        />
        <FormFieldSet
          type="file"
          title="Attachment"
          placeholder="No file Chosen"
          onChange={(files) => handleChange("attachment", files)}
          value={formData.attachment}
          error={errors.attachment}
          disabled={!isEditable}
        />
        {/* <Attachments */}
        {docs.map((doc, index) => {
          if (doc) {
            let data = [];
            data.push({
              filePath: [doc],
              name: index === 0 ? "Void Check" : "Attachment",
            });
            return <DocumentsList key={index} data={data} type="inner" />;
          }
          return null;
        })}   
      </div>
       <NewTable
          showCheckbox
          columns={AllConfidentialColumns}
          rows={mappedRows}
          toolbarRight={[
            { filterButton: false },
            { DropdownMenu: false },
          ]}
        />
    </div>
  );
};

export default Confidential;
